<template>
  <div class="sp-bottom-nav" aria-label="SPボトムナビゲーション">
    <template v-for="item in items" :key="item.label">
      <SpaInternalLink
        v-if="item.href"
        class="sp-bottom-nav__item"
        :class="{ 'sp-bottom-nav__item--scout': item.label === 'スカウト/おすすめ' }"
        :data-active="isActive({ label: item.label })"
        :href="item.href"
      >
        <span v-if="item.badgeCount && item.badgeCount > 0" class="sp-bottom-nav__badge">
          {{ item.badgeCount > 99 ? '99+' : item.badgeCount }}
        </span>
        <img
          :src="isActive({ label: item.label }) ? item.iconActive : item.icon"
          :alt="item.label"
          class="sp-bottom-nav__icon"
        />
        <span class="sp-bottom-nav__label">{{ item.label }}</span>
      </SpaInternalLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import SpaInternalLink from '@/components/shared/SpaInternalLink.vue';
import type { NavItem, SpBottomNavItem } from './types.d';
import { SP_BOTTOM_NAV_HEIGHT } from './constants';

defineProps<{
  items: (SpBottomNavItem & { badgeCount?: number })[];
  isActive: (item: NavItem) => boolean;
}>();

const bottomNavHeight = `${SP_BOTTOM_NAV_HEIGHT}px`;
</script>

<style scoped lang="scss">
@import '@/assets/css/_variables.scss';
@import '@/assets/stylesheets/components/_variables.scss';

.sp-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 330px;
  height: v-bind(bottomNavHeight);
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  font-size: 10px;
  color: #fff;
  background: $primary-dark;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.08);
  z-index: $z-navigation;
}

.sp-bottom-nav__item {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #ffffff;
  gap: 8px;
  border-bottom: 4px solid transparent;
  padding-top: 4px;
  position: relative;
}

.sp-bottom-nav__item[data-active='true'] {
  background: #f0f9fc;
  border-bottom: 4px solid $primary-dark;
  color: $primary-dark;
}

.sp-bottom-nav__icon {
  width: 25px;
  height: 25px;
}

.sp-bottom-nav__label {
  font-size: 10px;
  line-height: 1.4;
}

.sp-bottom-nav__item--scout {
  min-width: 104px;
}

.sp-bottom-nav__badge {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(16px);
  min-width: 22px;
  padding: 3px 6px;
  border-radius: 999px;
  background: #dc3545;
  color: #ffffff;
  font-size: 10px;
  line-height: 1.2;
  text-align: center;
  box-shadow: 0 0 0 1px #ffffff;
}
</style>
